var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('transition',{attrs:{"name":"fade"}},[(_vm.show)?_c('wait-screen',{staticClass:"topmost",attrs:{"title":_vm.message,"progress":_vm.progress,"message":_vm.details}}):_vm._e()],1),_c('div',[_vm._t("default")],2)],1)}
var staticRenderFns = []

export { render, staticRenderFns }